import { ChevronLeft, ChevronRight } from 'lucide-react';
import { IconButton } from '@shared/components';
import styles from './TablePagination.module.css'

function TablePagination({
  count,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  rowsPerPageOptions = [10, 25, 50],
  labelRowsPerPage = "Rows per page:",
  labelDisplayedRows = ({ from, to, count }) => `${from}-${to} of ${count}`
}) {
  const from = count === 0 ? 0 : page * rowsPerPage + 1;
  const to = Math.min(count, (page + 1) * rowsPerPage);
  const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

  const handleBackClick = () => {
    onPageChange(null, page - 1);
  };

  const handleNextClick = () => {
    onPageChange(null, page + 1);
  }

  const handleRowsPerPageChange = (event) => {
    onRowsPerPageChange(event);
  };

  return (
    <div className={styles.container}>
      <div className={styles.toolbar}>
        <div className={styles.selectRoot}>
          <span className={styles.caption}>{labelRowsPerPage}</span>
          <select
            className={styles.select}
            aria-label='Page select'
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
          >
            {rowsPerPageOptions.map((option) => (
              <option
                className={styles.option}
                key={option}
                value={option}
              >
                {option}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.displayedRows}>
          {labelDisplayedRows({ from, to, count })}
        </div>

        <div className={styles.action}>
          <IconButton
            onClick={handleBackClick}
            disabled={page === 0}
            color={"var(--color-primary)"}
            size="2rem"
          >
            <ChevronLeft />
          </IconButton>
          <IconButton
            onClick={handleNextClick}
            disabled={page >= lastPage}
            color={"var(--color-primary)"}
            size="2rem"
          >
            <ChevronRight />
          </IconButton>
        </div>
      </div>
    </div>
  );
}

export default TablePagination;